module.exports = __webpack_public_path__ + "img/ecosystem_fx.3c279a12.png";